import { ArrowBottomLeftBoldOutlineIcon } from './ArrowBottomLeftBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B34E6142-64AF-43FE-A565-2FAEEA35B800
 * name arrow-bottom-left-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-left-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowDownLeftBoldOutlineIcon = ArrowBottomLeftBoldOutlineIcon;
export default ArrowDownLeftBoldOutlineIcon